import { render, staticRenderFns } from "./why-is-my-instagram-download-blurry.vue?vue&type=template&id=b0238aa8"
import script from "./why-is-my-instagram-download-blurry.vue?vue&type=script&lang=js"
export * from "./why-is-my-instagram-download-blurry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports